import axios from 'axios';

const api = axios.create({
    baseURL: 'https://orcamentodigital.app/',
    // baseURL: 'https://191.252.201.140:8000',
    // baseURL: 'http://127.0.0.1:8000/',
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

export default api;
